// extracted by mini-css-extract-plugin
export default {"overlay":"Spinner_overlay__aSEIH","spinner":"Spinner_spinner__WgOJG","s7":"Spinner_s7__XIwEn"};